module.exports = __webpack_public_path__ + "media/images/front/cards-05762923892b45841620f663f09339ca.png";